import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import ClaimInviteDialog from '../../dialogs/claim.invite';
import { useQueryClient } from '@tanstack/react-query';

export default function Launcher(props) {
  const config = useDialogConfig();
  const queryClient = useQueryClient();

  const offer = useConnect('offer.byId', {
    id: config.params.offerId
  });

  const user = useConnect('user.byId', {
    id: config.params.userId
  });

  if (
    offer.state === PayloadStates.FETCHING ||
      user.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  return (
    <ClaimInviteDialog
      offer={offer}
      user={user}
      onCancel={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['claim'] });
      }}
    />
  );
};
